import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import {useTranslation} from "react-i18next";
import "../../css/main.css"

export default function ListModal({ openArchiveListModal, handleArchiveListModalClose, handleArchiveList, avoidMisfire}) {
    const { t } = useTranslation();
    
    return (
        <Dialog open={openArchiveListModal} onClose={handleArchiveListModalClose} className="modal-background-color">
            <DialogTitle>{t("modal.warning")}</DialogTitle>
            <DialogContent className="white-txt-color">
                {t("modal.archive_list")}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleArchiveListModalClose} className="button-dark-bg">
                    {t("global.cancel")}
                </Button>
                <Button onClick={handleArchiveList} disabled={avoidMisfire} className="button-dark-bg">
                    {t("modal.archive")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}